import React from 'react';
import illustration from '../../assets/Images/Group 196.webp';
import screenImage from '../../assets/Images/Group 277.webp';
import '../../styles/StudentComponents/WhyStrawket.css';

const WhyStrawket = () => {
  return (
    <section className="why-section">
      <h2 className="why-title">Why should you love Strawket</h2>

      {/* Top Section */}
      <div className="why-top">
        <div className="why-text">
          <h3>Learn something exciting every day:</h3>
          <p>
            From gaming to science experiments, there’s always something new to explore.
            Find your passion and develop real-world skills with Strawket.
          </p>
          {/* <div className="why-nav">← Next →</div> */}
        </div>
        <div className="why-image">
          <img src={illustration} alt="Kids Learning Illustration" />
        </div>
      </div>

      {/* Bottom Section */}
      <div className="why-bottom">
        <div className="why-screens">
          <img src={screenImage} alt="Stacked UI Screens" className="screen" />
        </div>
        <div className="why-features">
          <div className="feature-block">
            <h4>Easy schedule management</h4>
            <p>No more juggling class times! Adjust and manage your learning schedule effortlessly in one place.</p>
            {/* <a href="#">Learn More →</a> */}
          </div>
          <div className="feature-block">
            <h4>Seamless payments</h4>
            <p>Simple, secure and stress-free payments — so the learning never gets interrupted.</p>
            {/* <a href="#">Learn More →</a> */}
          </div>
          <div className="feature-block">
            <h4>Real-time progress tracking</h4>
            <p>Stay informed with clear progress reports. Track skill development, achievements, and milestones, so you always know.</p>
            {/* <a href="#">Learn More →</a> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyStrawket;
